import { TicketAvailability } from '../../enums';

import {
  getAllTicketsForRace,
  getAllAvailableTicketsForRace,
  getTicketAvailabilityType,
} from '../ticket';

const { AVAILABLE, COMING_SOON, ENTRY_CLOSED, SOLD_OUT } = TicketAvailability;

/**
 * Retuns an object summarising ticket availability given a races array.
 * Optionally takes a filter to apply to each tickets array.
 */
export default (races = [], filter = (n) => n) => {
  // TODO(orange): Modify api to consider these AVAILABLE.
  // For historical reasons, third party tickets without urls
  // are considered unavailable by the api
  const hasAvailableTickets = races.some(
    (race) => getAllAvailableTicketsForRace(race).filter(filter).length,
  );
  if (hasAvailableTickets) {
    return { type: AVAILABLE };
  }

  const availabilityTypes = []
    .concat(...races.map(getAllTicketsForRace))
    .filter(filter)
    .map(getTicketAvailabilityType);

  // "Coming Soon" if any are coming soon
  if (availabilityTypes.includes(COMING_SOON)) {
    return { type: COMING_SOON };

    // "Sold out" if any others are sold out
  }
  if (availabilityTypes.includes(SOLD_OUT)) {
    return { type: SOLD_OUT };
  }

  // "Entry closed" in other cases, "Not available" or partially "Sold out" are overlooked
  return { type: ENTRY_CLOSED };
};
